/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const DiffInformationBanner = styled.span({
  width: '100%',
  position: 'sticky',
  fontFamily: token('font.family.body'),
  top: '96px',
  zIndex: 100,
  display: 'inline-block',
  textAlign: 'center',
  flexDirection: 'column',
  backgroundColor: token('color.background.brand.boldest'),
  color: token('color.text.inverse'),
  button: {
    cursor: 'pointer',
    outline: 'none',
    color: token('color.text.inverse'),
    textDecoration: 'underline',
    background: 'transparent',
  },
});

export default DiffInformationBanner;
